import { CustomerDocument } from 'generated-api/bff/api';

export enum TitleReplaceEnum {
	Notification = 'E-mail',
	KundeMail = 'E-mail',
	Document = 'Dokument',
	KundeBrev = 'Dokument',
	Forslag = 'Dokument',
	Volapyk = 'Dokument',
}

export interface MessagePDF {
	data: Blob;
	fileName: string;
}

export interface FormattedCustomerDocument extends CustomerDocument {
	formattedDate?: string;
	dateMinusDot?: string;
	numberOfUnreadDocs?: number;
}
